import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { api, formatApiError, EMAIL_PATTERN } from "../../lib/api";
import { AuthShell } from "../../components/admin/AuthShell";
import { FormAlert, inputClass } from "../../components/forms/FormKit";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_PATTERN.test(email)) return setError("Enter a valid email address.");
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Reset password">
      {done ? (
        <div role="status" data-testid="forgot-password-success">
          <MailCheck className="h-9 w-9 text-[#2563EB]" strokeWidth={1.5} />
          <h1 className="mt-6 font-display text-2xl font-semibold text-[#0B1220]">Check your email</h1>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">{done} The link expires in 60 minutes and can be used once.</p>
          <Link to="/admin/login" className="link-arrow mt-8" data-testid="forgot-back-to-login">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} noValidate data-testid="forgot-password-form">
          <h1 className="font-display text-3xl font-semibold tracking-tight text-[#0B1220]">Reset password</h1>
          <p className="mt-2 text-sm text-slate-500">Enter your administrator email. If an account exists, we will send a secure reset link.</p>
          <label htmlFor="forgot-email" className="mb-2 mt-8 block text-sm font-medium text-[#111827]">Email</label>
          <input id="forgot-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass(false)} data-testid="forgot-email-input" />
          <div className="mt-5"><FormAlert message={error} testId="forgot-error" /></div>
          <button type="submit" disabled={busy} className="btn-primary mt-5 w-full" data-testid="forgot-submit-button">
            {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Sending</> : "Send reset link"}
          </button>
          <Link to="/admin/login" className="mt-6 block text-center text-sm text-slate-500 hover:text-[#0B1220]" data-testid="forgot-login-link">Back to sign in</Link>
        </form>
      )}
    </AuthShell>
  );
}
